import React from 'react';
import Text from '../Text';

class Checkbox extends React.Component {
  onCheck = () => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(!this.props.checked);
    }
  };
  render() {
    return (
      <div className="f-columns f-sc pointer">
        <i
          name="checkbox-box"
          onClick={this.onCheck}
          className={
            ((this.props.checked && 'fal fa-check-square') || 'fal fa-square') +
            ' primaryDark fa-2x'
          }
        />
        <Text mx={3} noclip name="checkbox-label">
          {this.props.label}
        </Text>
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components_new/common/FormComponents/Checkbox.js